var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyrightLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6676 10.9999C11.2477 11.5594 10.6625 11.9727 9.99473 12.1812C9.32697 12.3897 8.61054 12.3828 7.94691 12.1615C7.28328 11.9402 6.70608 11.5158 6.29707 10.9483C5.88807 10.3807 5.66797 9.69892 5.66797 8.99937C5.66796 8.29982 5.88805 7.618 6.29705 7.05047C6.70605 6.48294 7.28324 6.05847 7.94687 5.83718C8.6105 5.6159 9.32693 5.609 9.99469 5.81748C10.6625 6.02596 11.2477 6.43924 11.6675 6.99879",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyrightLogo);
export default __webpack_public_path__ + "static/media/copyright_logo.60a81b1d4f1fd720c9064fa069751bbb.svg";
export { ForwardRef as ReactComponent };